import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { getCookie } from './cookies'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function sleep(ms: number = 1000) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export async function api<T = any>(
  path: string,
  options?: RequestInit
): Promise<T> {
  const token = getCookie('token');
  const res = await fetch(`${path}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
      ...(options?.headers || {})
    },
    ...options
  });

  if (!res.ok) {
    const msg = await res.text();
    throw new Error(`API error: ${msg}`);
  }

  return res.json();
}